// hooks/ToolsProvider.jsx
import { useEffect, useState } from "react";
import { toolsContext } from "./Context";


const API_KEY = process.env.REACT_APP_API_URL

export function ToolsProvider({ children }) {
  const [tools, setTools] = useState([]);

  useEffect(() => {
    fetch(`${API_KEY}/api/apps`)
      .then((res) => res.json())
    .then((data) => {
      setTools(data);
    })
    .catch((err) => console.error("Failed to fetch tools:", err));
}, []);

  return (
    <toolsContext.Provider value={tools}>
      {children}
    </toolsContext.Provider>
  );
}
